import { useTranslation } from 'react-i18next';

const NotificationMessages = () => {
  const { t } = useTranslation();
  return {
    changeStatusUpdate: t('messages.statusActual'),
    changeCreate: t('messages.changeCreate'),
    chagneUpdate: t('messages.changeUpdate'),
    workPackageCreate: t('messages.workUpdate'),
    workPackageUpdate: t('messages.workUpdate'),
    processUpate: t('messages.processUpdate'),
    processCreate: t('messages.statusActual'),
    workPackageStatusUpdate: t('messages.workUpdate'),
    workPackageAllStatusesUpdate: t('messages.workUpdate'),
    workPackageDelete: t('messages.workDelete'),
    processAdd: t('messages.processAdde'),
    processUpdate: t('messages.processUpdate'),
    processDelete: t('messages.processDelete'),
    processUnique: t('messages.groupNoProcessNo'),
    error: t('messages.error'),
    calcDocMissing: t('messages.calcDocMissing'),
    userAdded: t('messages.userAdded'),
    permissionChanged: t('messages.permissionChanged'),
    passwordReset: t('messages.passwordReset'),
    userUpdate: t('messages.userUpdate'),
    userDelete: t('messages.userDelete'),
  };
};

export default NotificationMessages;
